import { isBrowser, } from "@shipt/analytics-core";
import { getContext, getAnonymousId, postWorkerMessage } from "./utils/browser";
/**
 *
 * @param name - page name
 * @param properties - page event properties
 * @param options - top level page options to send in request payload (sans properties)
 */
export const page = (name, properties, options) => {
    try {
        if (!isBrowser()) {
            return;
        }
        const payload = {
            ...options,
            anonymousId: getAnonymousId(),
            context: getContext(options === null || options === void 0 ? void 0 : options.context),
            type: "page",
            name,
            properties,
        };
        postWorkerMessage({ options: payload });
    }
    catch (e) {
        console.error(e);
    }
};
